export default __webpack_public_path__ + "static/media/1 (2).443402c5.jpg";